import { gql, useQuery } from '@apollo/client'

const FORM_DETAIL_QUERY = gql`
  query FormDetail($formId: Long!) {
    form(id: $formId) {
      id
      name
      status
      endDate
      beginDate
      sector {
        id
        name
      }
      questions {
        id
        text
        textFuture
        type
        description
        notApplicable
        dimension {
          id
          name
        }
        options {
          id
          value
        }
      }
    }
  }
`

export function useFormDetailQuery(formId, options = {}) {
  const { data, ...rest } = useQuery(FORM_DETAIL_QUERY, {
    ...options,
    variables: {
      ...options.variables,
      formId
    }
  })

  return {
    data: data?.form,
    ...rest
  }
}
